import * as React from "react";

export class Root extends React.Component {
  public render(): JSX.Element {
    return (
      <div className="root">
        { this.props.children }
      </div>
    );
  }
}